import React, { useContext } from 'react';
import { ContextMenu, MenuItem } from 'react-contextmenu';
import WorkspaceContext from '../Context/WorkspaceContext';
import AppContext from '../Context/AppContext';

const WorkspaceContextMenu = props => {
  const { currentView, screenReference, entity } = useContext(WorkspaceContext);
  const app = useContext(AppContext);

  let actionButtons = [];
  if (props.rowIdx >= 0) {
    let selectedRow = props.rowGetter(props.rowIdx);

    if (props.renderActionButtons) {
      actionButtons = props.renderActionButtons({
        rowData: selectedRow,
        rowIdx: props.rowIdx,
        columnIdx: props.idx,
        currentView,
        screenReference,
        entity,
        app,
      });
    }
  }

  if (props.deleteOption) {
    actionButtons.push(
      <MenuItem
        key={'actionButtonDelete'}
        onClick={e => {
          e.preventDefault();
          props.deleteOption(props.rowIdx);
        }}
      >
        Delete
      </MenuItem>
    );
  }

  if (!actionButtons || actionButtons.length === 0) {
    return null; //No point displaying an empty menu...
  }

  return (
    <div>
      <ContextMenu id={`context_menu_trigger_${props.contextKey}`}>{actionButtons}</ContextMenu>
    </div>
  );
};

WorkspaceContextMenu.defaultProps = {
  deleteOption: null,
};

export default WorkspaceContextMenu;
